import { getStringTag } from 'features/libra/helpers/getStringTag'
import { GeckoMarkupLayer, RolodexEntryType } from 'types'

export const FFS_LTA_PATHS_MARKUP_PATH = 'FFS LTA Paths'

/**
 * Persisted FFS service output appears under this markup group in the details
 * page. If the backend adds an indication-set tag, use it to avoid mixing
 * generated sets; older output is matched by path only.
 */
export function isFfsLtaPathMarkupLayer(
  layer: GeckoMarkupLayer,
  ltaSetId: string
): boolean {
  if (layer.access_restriction === 'internal') return false
  if (layer.data.path?.[0] !== FFS_LTA_PATHS_MARKUP_PATH) return false

  const layerIndicationSetId = getStringTag(
    layer.tags,
    RolodexEntryType.INDICATION_SET
  )
  return !layerIndicationSetId || layerIndicationSetId === ltaSetId
}
